var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en

require('ui-select/dist/select.min.css')
require('ui-select/dist/select.js')

angular.module('inputPobockyCmp', ['ui.select'])
  .component('inputPobocky', {
    template: require('./input-pobocky.component.tpl.html'),
    controller: InputPobockyCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '=',
      defaultBranchId: '<',
      ngDisabled: '<',
      onChanged: '&',
      inputRf: '@',
      errorRf: '@'
    }
  })

InputPobockyCtrl.$inject = ['i18n']

function InputPobockyCtrl (i18n) {
  var vm = this

  vm.searchEnabled = true

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.branches = Object.keys(vm.formField.branchTypeMap).map(function (key) {
      return vm.formField.branchTypeMap[key]
    })

    if (vm.defaultBranchId || vm.formField.defaultValueI18N) {
      var defaultBranchId = vm.defaultBranchId || vm.formField.defaultValueI18N
      setDefaultBranch(defaultBranchId)
    }
  }

  function setDefaultBranch (branchId) {
    vm.value[vm.formField.id] = parseInt(branchId)
  }
}
